module.exports = __webpack_public_path__ + "img/Führungsgruppe_TEL.00d793c3.svg";